import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { EmailContentService } from '../../core/services/email-content.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-email-content-edit',
    imports: [MaxLengthValidatorDirective, RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i>&nbsp;編集</span>
    </div>
    <div class="card-body">
      <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
      @if (loading) {
        <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
      }
      @if (!loading) {
        <form novalidate #emailContentForm="ngForm">
          <div class="form-group row">
            <div class="col-md-12">
              <label class="col-form-label">件名</label>
              <input type="text" class="form-control" [(ngModel)]="form.subject" name="subject" placeholder="件名（255文字以内）" maxlength="255" required>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label class="col-form-label">本文</label>
              <textarea class="form-control" [(ngModel)]="form.message" name="message" rows="20" placeholder="本文（65535文字以内）" sfMaxLength="65535" required></textarea>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12 text-right">
              <a class="btn bg-close text-white" routerLink="/email/content"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
              @if (form.isAuthor) {
                <button type="button" class="btn btn-success ml-1" (click)="save(emailContentForm)" [disabled]="saving || emailContentForm.invalid">
                  <i class="fa s-icon-save"></i>&nbsp;保存
                </button>
              }
            </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>
  `
})
export class EmailContentEditComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private emailContentService = inject(EmailContentService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private flash = inject(FlashService);

  form: any = {};
  loading = true;
  saving = false;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('文面作成', 'edit_note', true);
    const id = +this.route.snapshot.params['id'];
    try {
      this.form = await this.emailContentService.getOne(id) ?? { id };
    } finally {
      this.loading = false;
    }
  }

  async save(form?: NgForm): Promise<void> {
    if (form?.invalid || !this.form?.isAuthor) {
      form?.control.markAllAsTouched();
      return;
    }
    this.saving = true;
    try {
      const payload = { ...this.form, status: 1 };
      delete payload.isAuthor;
      delete payload.studio;
      const result: any = await this.emailContentService.upsert(payload);
      // 旧版 email-content.js:198-211: 予約利用中はdangerで画面維持、それ以外success後に一覧へ（一覧の通知欄に表示）
      if (result?.isReservationExists) {
        this.flash.create('danger', '配信予約で使用中のメール文面は編集できません。');
        window.scrollTo(0, 0);
      } else {
        this.flash.create('success', 'メール文面を更新しました。');
        this.router.navigate(['/email/content']);
      }
    } finally {
      this.saving = false;
    }
  }
}
